import { apiRequest, announcementCreate } from "../../../../services/adapters/base";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      announcementCreate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
